import React from 'react'
import { makeStyles } from '@material-ui/core'

const HMapInstructionTop = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <p className={classes.title}>Instructions</p>
      <p className={classes.text}>
        Here are the instructions on how to use heatmaps:
      </p>
      <span className={classes.text}>
        <ol>
          <li>
            You will be presented with pre-created heatmaps from the company and
            the system. These heatmaps are designed to provide you with valuable
            information about your data.
          </li>
        </ol>
      </span>
      <span className={classes.text}>
        <ol start="2">
          <li>Each heatmap has three options:</li>
        </ol>
        <ul>
          <li className={classes.textSpacer}>
            The first option is to mark the heatmap as a favorite. When you do
            it will be displayed at the top of the list for easy access.
          </li>
          <li className={classes.textSpacer}>
            The second option is a pin icon that you can use to display the
            heatmap on your map legend.
          </li>
          <li className={classes.textSpacer}>
            The third option is a radio button that you can use to activate the
            heatmap and it will be displayed on your map.
          </li>
        </ul>
      </span>
      <span className={classes.text}>
        <ol start="3">
          <li>Please note that only one heatmap can be visible at a time.</li>
        </ol>
      </span>
    </div>
  )
}

export default React.memo(HMapInstructionTop)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  title: {
    width: '100%',
    ...theme.typography.h3,
    color: theme.palette.tertiary.main
  },
  text: {
    ...theme.typography.p,
    color: theme.palette.primary.main
  },
  textSpacer: {
    margin: '0 0 10px 10px'
  }
}))
